import { render, staticRenderFns } from "./ScheduleSettings.vue?vue&type=template&id=478ff602&scoped=true&"
import script from "./ScheduleSettings.vue?vue&type=script&lang=ts&"
export * from "./ScheduleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478ff602",
  null
  
)

export default component.exports